module.exports = __webpack_public_path__ + "img/call.9a16ddcb.png";